import { useMemo } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";

import "../css/WhatsAppEnquiryButton.css";

const WHATSAPP_NUMBER =
  process.env.REACT_APP_WHATSAPP_NUMBER || "919836610337";

const isProductRoute = (pathname) =>
  /^\/shop-details\/[^/]+\/?$/.test(pathname);

const isVideoMedia = (media) => {
  const mediaType = String(media?.media_type || "").toLowerCase();
  const mediaUrl = String(media?.image_url || "").toLowerCase();

  return (
    mediaType === "video" ||
    /\.(mp4|mov|webm)(?:\?|$)/.test(mediaUrl)
  );
};

const getProductImageUrl = (product) => {
  const imageMedia = (Array.isArray(product?.media) ? product.media : []).filter(
    (media) => media?.image_url && !isVideoMedia(media)
  );
  const primaryImage =
    imageMedia.find((media) => media.is_primary) || imageMedia[0];

  return (
    primaryImage?.image_url ||
    product?.image_url ||
    product?.primary_image ||
    product?.image ||
    ""
  );
};

const isHiddenRoute = (pathname) => {
  const hiddenRoutes = [
    "/cart",
    "/checkout",
    "/payment-return",
    "/order-success",
    "/order-cancelled",
  ];

  return hiddenRoutes.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );
};

const WhatsAppEnquiryButton = ({ product = null }) => {
  const location = useLocation();

  const whatsappUrl = useMemo(() => {
    const pageUrl = `${window.location.origin}${location.pathname}${location.search}`;
    const productName = product?.product_name || product?.name || "";
    const categoryName =
      product?.category?.name || product?.category_name || "";
    const imageUrl = getProductImageUrl(product);
    const hasProductContext =
      isProductRoute(location.pathname) && Boolean(productName);

    const message = hasProductContext
      ? [
          "Hello Graphe Weddings!",
          "",
          "I would like to enquire about this product:",
          `Product name: ${productName}`,
          categoryName ? `Category: ${categoryName}` : null,
          `Product URL: ${pageUrl}`,
          imageUrl ? `Image URL: ${imageUrl}` : null,
          "",
          "Please help me with the available options, pricing, customisation possibilities, minimum quantity, and estimated timeline.",
          "",
          "Custom requirements:",
          "Approximate quantity:",
          "Event date:",
        ]
          .filter((line) => line !== null)
          .join("\n")
      : [
          "Hello Graphe Weddings!",
          "",
          "I would like to enquire about your wedding stationery products and services. I may also need something custom-made.",
          "",
          "Please help me with the available options, pricing, customisation possibilities, minimum quantity, and estimated timeline.",
          "",
          "Product or service I am interested in:",
          "Custom requirements:",
          "Approximate quantity:",
          "Event date:",
          "",
          `Page I was viewing: ${pageUrl}`,
        ].join("\n");

    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  }, [location.pathname, location.search, product]);

  if (isHiddenRoute(location.pathname)) return null;

  return (
    <div className="whatsapp-enquiry-wrap">
      <a
        className="whatsapp-enquiry-button"
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Enquire about products, services, or a custom order on WhatsApp"
        title="Custom product and service enquiries"
      >
        <span className="whatsapp-enquiry-icon" aria-hidden="true">
          <FaWhatsapp />
        </span>
        {/* <span className="whatsapp-enquiry-copy">
          <small>Need something custom?</small>
          <strong>Chat on WhatsApp</strong>
        </span> */}
      </a>
    </div>
  );
};

export default WhatsAppEnquiryButton;
